import React, { Component, PropTypes } from "react";
import {
	NitroLoading,
	NitroContentNotAvailable,
	NitroText,
	NitroIcon
} from "nitro-components";

import styled from "styled-components";

import { boolStyle } from "style-utils";

const DriverListItemContainer = styled.li`
	list-style-type: none;
	display: flex;
	flex-direction: row;
	padding: 16px;
	border-bottom: 1px solid ${props => props.theme.color.border};
	background:${props => (props.selected ? "#f7f7f7" : "none")};
	padding: ${props => (props.selected ? "16px 16px 17px 16px" : "16px")};
	border-bottom: ${props => (props.selected || props.tableItem ? "none" : `1px solid ${props => props.theme.color.border}`)};
	
	cursor: ${props => (props.disableHoverStyle ? "inherit" : "pointer")};

	&:active, &:hover {
		background:${props => (props.disableHoverStyle ? "none" : "#f7f7f7")};
		border-radius: 4px;
		border: none;
		padding-bottom: ${props => (props.disableHoverStyle ? "16px" : "17px")};
	}
`;
const NitroIconHolder = styled.section`
	width: 10%;;
`;

const IndexHolder = styled.section`
	text-align: center;
	width: 20%;
`;

const DriverName = styled.section`
	width: 60%;
	overflow: hidden;
`;

class DriverListItem extends Component {
	render() {
		const {
			data,
			selected,
			index,
			tableItem,
			disableHoverStyle
		} = this.props;
		return (
			<DriverListItemContainer
				tableItem={tableItem}
				disableHoverStyle={disableHoverStyle}
			>
				<NitroIconHolder>
					{data.PotentialSuspension &&
						<NitroIcon
							name="suspended"
							size={16}
							variant="negative"
						/>}

				</NitroIconHolder>
				<IndexHolder>
					<NitroText size={3} variant="base3" bold>
						{index + 1}
					</NitroText>
				</IndexHolder>
				<DriverName>
					<NitroText size={3} variant="base1" bold>
						{data.DriverName}

					</NitroText>
				</DriverName>
				<NitroIconHolder>
					{selected &&
						<NitroIcon
							name="arrow-right"
							size={8}
							variant="negative"
							left={12}
						/>}

				</NitroIconHolder>
			</DriverListItemContainer>
		);
	}
}

DriverListItem.propTypes = {
	index: PropTypes.number,
	selected: PropTypes.bool,
	tableItem: PropTypes.bool,
	disableHoverStyle: PropTypes.bool
};

export default DriverListItem;



// WEBPACK FOOTER //
// ./src/features/insights/components/driverSafety/components/DriverListItem.js